<template>
  <div class="mz-listen-and-point" @click="cancelCheck()">
    <img
      v-if="startGameConfig.mainImage"
      @click="cancelCheck()"
      class="main-img"
      draggable="false"
      :src="giveMeImagePlease(startGameConfig.mainImage.imagePath)"
      :style="{
        width: setValue(startGameConfig.mainImage.width, 1920) + 'px',
        height: setValue(startGameConfig.mainImage.height, 1080) + 'px',
        top: setValue(startGameConfig.mainImage.pos.x, 0) + 'px',
        left: setValue(startGameConfig.mainImage.pos.y, 0) + 'px',
      }"
    />
    <mz-mask-in-game
      :key="'mz-mask-' + index"
      v-for="(data, index) in startGameConfig.staticMaskConfig"
      :item-data="data"
      :mask-data="maskData"
      @change-item-mask="changeItemMask"
      style="z-index: 10008"
    ></mz-mask-in-game>
    <div
      :key="'mz-listen-and-point-item-' + index"
      class="mz-listen-and-point-item"
      v-for="(it, index) in items"
      :style="{
        'z-index': '10007',
        width: setValue(it.width, 200) + 'px',
        height: setValue(it.height, 200) + 'px',
        top: setValue(it.pos.y, 0) + 'px',
        left: setValue(it.pos.x, 0) + 'px',
        background: setValue(it.background, 'transparen'),
        backgroundImage: it.backgroundImage ? 'url(' + giveMeImagePlease(it.backgroundImage) + ')' : '',
        backgroundSize: 'cover',
        filter: !it.correctStatus && blockItems && currentIndex != index ? 'grayscale(100%)' : 'grayscale(0%)',
        visibility: 'hidden',
      }"
    >
      <div class="audio" v-if="it.audio" style="max-width: 100%; pointer-events: stroke; max-height: 100%">
        <div v-if="checkAudioIcon()" style="width: 100%; height: 100%; position: absolute; top: 0; left: 0">
          <img
            @load="loadInstedOfClick(index)"
            :src="giveMeImagePlease(startGameConfig.audio.icon.on)"
            draggable="false"
            v-if="!it.audioStatus"
            style="width: 100%; height: 100%; position: absolute; top: 0; left: 0"
          />
          <img
            :src="giveMeImagePlease(startGameConfig.audio.icon.off)"
            draggable="false"
            v-if="it.audioStatus"
            style="width: 100%; height: 100%; position: absolute; top: 0; left: 0"
          />
        </div>
        <svg v-if="!checkAudioIcon()" class="audio-svg-button" viewBox="0 0 24 24" style="cursor: pointer">
          <transition name="click-fade">
            <path
              v-if="!it.audioStatus"
              d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"
            />
          </transition>
          <transition name="click-fade">
            <path
              v-if="it.audioStatus"
              d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"
            />
          </transition>
        </svg>
      </div>
      <div
        class="blocker"
        v-if="(blockItems && currentIndex != index) || it.correctStatus"
        @click="playCorrectFieldAudio(it.audio, it.correctStatus)"
      >
        <div class="mz-listen-and-point-item-correct-items" v-if="it.correctItems && it.correctStatus">
          <img
            :key="'mz-listen-and-point-item-correct-items-image-' + indexCorrImg"
            draggable="false"
            class="mz-listen-and-point-item-correct-image"
            v-for="(correctImg, indexCorrImg) in it.correctItems.images"
            :src="giveMeImagePlease(correctImg.src)"
            :style="{
              width: setValue(correctImg.width, 100) + 'px',
              height: setValue(correctImg.height, 100) + 'px',
              top: correctImg.pos ? setValue(correctImg.pos.y, 0) + 'px' : '0' + 'px',
              left: correctImg.pos ? setValue(correctImg.pos.x, 0) + 'px' : '0' + 'px',
            }"
          />
        </div>
      </div>
    </div>
    <div
      :key="'mz-listen-and-point-item-correct-' + indexCor"
      class="mz-listen-and-point-item"
      v-for="(corr, indexCor) in correct"
      @click="
        startGameConfig.audio && startGameConfig.audio.click ? audioClick.play() : '';
        checkCorrect(corr, indexCor);
      "
      :style="[
        {
          width: setValue(corr.width, 200) + 'px',
          height: setValue(corr.height, 200) + 'px',
          top: setValue(corr.pos.y, 0) + 'px',
          left: setValue(corr.pos.x, 0) + 'px',
          background: setValue(corr.background, 'transparen'),
        },
        corr.cssStyle,
      ]"
    >
      <p v-if="corr.text" :style="corr.cssTextStyle" v-html="corr.text" class="mz-listen-and-point-item-txt"></p>
      <img
        v-if="corr.image"
        :src="giveMeImagePlease(corr.image.src)"
        class="mz-listen-and-point-item-img"
        draggable="false"
      />

      <div
        class="audio"
        v-if="corr.audio"
        style="max-width: 100%; pointer-events: stroke; z-index: 1006; max-height: 100%"
      >
        <div
          v-if="checkAudioIcon()"
          @click="
            startGameConfig.audio && startGameConfig.audio.click ? audioClick.play() : '';
            playFieldAudio(corr.audio, indexCor);
          "
          style="width: 100%; height: 100%; position: absolute; top: 0; left: 0"
        >
          <img
            :src="giveMeImagePlease(startGameConfig.audio.icon.on)"
            v-if="!corr.audioStatus"
            draggable="false"
            style="width: 100%; height: 100%; position: absolute; top: 0; left: 0"
          />
          <img
            :src="giveMeImagePlease(startGameConfig.audio.icon.off)"
            v-if="corr.audioStatus"
            draggable="false"
            style="width: 100%; height: 100%; position: absolute; top: 0; left: 0"
          />
        </div>
        <svg
          @click="
            startGameConfig.audio && startGameConfig.audio.click ? audioClick.play() : '';
            playFieldAudio(corr.audio, indexCor);
          "
          class="audio-svg-button"
          viewBox="0 0 24 24"
          style="cursor: pointer"
          v-if="!checkAudioIcon()"
        >
          <transition name="click-fade">
            <path
              v-if="!corr.audioStatus"
              d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"
            />
          </transition>
          <transition name="click-fade">
            <path
              v-if="corr.audioStatus"
              d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"
            />
          </transition>
        </svg>
      </div>
      <div class="blocker" v-if="corr.correctStatus">
        <div class="mz-listen-and-point-item-correct-items" v-if="corr.correctItems && corr.correctStatus">
          <img
            :key="'mz-listen-and-point-item-correct-items-image-' + indexCorrImgCorr"
            class="mz-listen-and-point-item-correct-image"
            draggable="false"
            v-for="(correctImgCorr, indexCorrImgCorr) in corr.correctItems.images"
            :src="giveMeImagePlease(correctImgCorr.src)"
            :style="{
              width: setValue(correctImgCorr.width, 100) + 'px',
              height: setValue(correctImgCorr.height, 100) + 'px',
              top: correctImgCorr.pos ? setValue(correctImgCorr.pos.y, 0) + 'px' : '0' + 'px',
              left: correctImgCorr.pos ? setValue(correctImgCorr.pos.x, 0) + 'px' : '0' + 'px',
            }"
          />
        </div>
        <div
          class="mz-listen-and-point-item-incorrect-items"
          v-if="corr.falseStatus !== undefined && corr.falseStatus !== false"
        >
          <img
            :key="'mz-listen-and-point-item-incorrect-items-image-' + indexIncorrImgIncorr"
            class="mz-listen-and-point-item-incorrect-image"
            draggable="false"
            v-for="(incorrectImgCorr, indexIncorrImgIncorr) in corr.incorrectItems.images"
            :src="giveMeImagePlease(incorrectImgCorr.src)"
            :style="{
              width: setValue(incorrectImgCorr.width, 100) + 'px',
              height: setValue(incorrectImgCorr.height, 100) + 'px',
              top: incorrectImgCorr.pos ? setValue(incorrectImgCorr.pos.y, 0) + 'px' : '0' + 'px',
              left: incorrectImgCorr.pos ? setValue(incorrectImgCorr.pos.x, 0) + 'px' : '0' + 'px',
            }"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Howler } from 'howler';
import _ from 'lodash';
import defaultMixin from '../../mixins/defaultMixin';
import mzMaskInGame from '__mainSrcDir/components/MzMask/MzMaskInGame';
export default {
  name: 'mz-listen-and-point',
  mixins: [defaultMixin],
  components: { mzMaskInGame },
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
    assets: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      maskData: [],
      canIPlayASong: true,
      items: [],
      blockItems: false,
      currentIndex: -1,
      hoverOnIcon: [],
      correct: [],
      audioClick: null,
      audioNegative: null,
      audioPositive: null,
      preventResetTable: false,
      tableCopy: [],
    };
  },
  created() {},
  beforeDestroy() {
    this.$store.commit('LOCK_GAME', false);
    if (this.currentIndex != -1) if (this.items[this.currentIndex].audio) this.items[this.currentIndex].audio.stop();
  },
  beforeMount() {
    if (this.startGameConfig.staticMaskConfig) {
      this.maskData = this.startGameConfig.staticMaskConfig.map(({ id }) => ({ id: id, isWrapped: true }));
      if (this.maskData.length > 0) this.$store.commit('LOCK_GAME', true);
    }
  },
  mounted() {
    // if (this.startGameConfig.blockCheck) {
    //   // this.$store.commit('CHANGE_BLOCK_CHECK_ACTION', true);
    // }
    this.setGameAudio();
    this.init();
  },
  methods: {
    loadInstedOfClick(index) {
      this.tableOfGroupIndexes[index] = index;
      this.tableCopy = Array.from(this.tableOfGroupIndexes);
      this.blockItems = true;
      this.currentIndex = index;
    },
    changeItemMask(value) {
      if (this.maskData.length > 0) {
        this.maskData = value.item;
        this.checkIfLocked();
      }
    },
    checkIfLocked() {
      if (this.maskData.length > 0) {
        if (this.maskData.filter((el) => el.isWrapped === true).length < this.maskData.length) {
          this.$store.commit('LOCK_GAME', false);
        } else {
          this.$store.commit('LOCK_GAME', true);
        }
      }
    },
    cancelCheck() {
      this.$store.commit('CHANGE_CHECK_SWITCH', false);
    },
    checkAudioIcon() {
      if (this.startGameConfig.audio) {
        if (this.startGameConfig.audio.icon) return true;
      }
      return false;
    },
    checkAllIndex() {
      console.log(this.items);
      if (this.items.every((x) => x.correctStatus == true) && this.correct.every((x) => x.correctStatus == true)) {
        return true;
      } else return false;
    },
    checkGameAction() {
      return this.checkAllIndex();
    },
    checkCorrect(corr, indCorr) {
      let newCurrentIndex = this.tableOfGroupIndexes[this.tableOfIndexes[indCorr]];
      if (this.currentIndex != -1 && newCurrentIndex != -1) {
        if (this.items[this.currentIndex].audio) {
          this.items[this.currentIndex].audio.stop();
          this.canIPlayASong = true;
        }
        if (corr.correctId == this.items[this.currentIndex].correctId) {
          this.audioPositive.play();
          console.log(this.audioPositive._duration);
          setTimeout(() => {
            corr.correctStatus = true;
            this.correctStatus(this.currentIndex, true);
            if (corr.correctId == this.items[this.currentIndex].correctId) this.blockItems = false;
            this.tableOfGroupIndexes[this.tableOfIndexes[indCorr]] = -1;
            this.currentIndex = -1;
            if (this.checkAllIndex()) {
              this.$store.dispatch('checkGame');
            }
          }, this.audioPositive._duration * 100 + 100);
        } else {
          if (this.startGameConfig.audio.negative) this.audioNegative.play();
          if (this.startGameConfig.falseStatus) corr.falseStatus = true;
          setTimeout(() => {
            this.blockItems = false;
            this.currentIndex = -1;
            corr.falseStatus = false;
          }, (this.startGameConfig.audio.negative ? this.audioNegative.duration() : 0.648) * 1000 + 100);
        }
      }
      if (this.currentIndex == -1 && newCurrentIndex != -1) {
        if (this.items[newCurrentIndex].audio) {
          this.items[newCurrentIndex].audio.stop();
          this.canIPlayASong = true;
        }
        if (corr.correctId == this.items[newCurrentIndex].correctId) {
          this.audioPositive.play();
          console.log(this.audioPositive._duration);
          setTimeout(() => {
            corr.correctStatus = true;
            this.correctStatus(newCurrentIndex, true);
            if (corr.correctId == this.items[newCurrentIndex].correctId) this.blockItems = false;
            this.tableOfGroupIndexes[this.tableOfIndexes[indCorr]] = -1;
            this.currentIndex = -1;
            if (this.checkAllIndex()) {
              this.$store.dispatch('checkGame');
            }
          }, this.audioPositive._duration * 100 + 100);
        } else {
          if (this.startGameConfig.audio.negative) this.audioNegative.play();
          if (this.startGameConfig.falseStatus) corr.falseStatus = true;
          setTimeout(() => {
            this.blockItems = !this.blockItems;
            this.currentIndex = -1;
            corr.falseStatus = false;
            this.blockItems = false;
          }, (this.startGameConfig.audio.negative ? this.audioNegative.duration() : 0.648) * 1000 + 100);
        }
      }
    },
    playFieldAudio(audio, index) {
      this.tableOfGroupIndexes[index] = index;
      console.log(this.canIPlayASong);
      if (audio && this.canIPlayASong) {
        audio.play();
      } else if (audio) {
        audio.stop();
      }
    },
    playCorrectFieldAudio(audio, corr) {
      console.log(audio.duration());
      if (audio && this.canIPlayASong && corr && this.currentIndex == -1) {
        this.blockItems = true;
        audio.play();
        setTimeout(() => {
          if (this.currentIndex == -1) this.blockItems = false;
        }, audio.duration() * 1000 + 100);
      } else if (audio && corr) {
        if (audio.playing()) {
          audio.stop();
          this.blockItems = false;
        }
      }
    },
    aduioStatus(index, value) {
      let it = this.items[index];
      it.audioStatus = value;
      this.$set(this.items, index, it);
    },
    correctStatus(index, value) {
      let it = this.items[index];
      it.correctStatus = value;
      this.$set(this.items, index, it);
    },
    audioCreate(src, index) {
      return new Howl({
        src: this.giveMeImagePlease(src),
        autoplay: false,
        loop: false,
        volume: 0.5,
        onend: () => {
          this.canIPlayASong = true;
          this.aduioStatus(index, false);
        },
        onstop: () => {
          this.canIPlayASong = true;
          this.aduioStatus(index, false);
        },
        onplay: () => {
          this.canIPlayASong = false;
          this.aduioStatus(index, true);
        },
      });
    },
    setItem(value, index, layout, config) {
      if (!value.pos) value.pos = layout[index].pos;
      value.audioStatus = false;
      if (value.audioSrc) {
        value.audio = this.audioCreate(value.audioSrc, index);
        value.hoverOnIcon = false;
      }
      if (!value.width) value.width = config.width;
      if (!value.height) value.height = config.height;
      if (!value.background) value.background = config.background;
      if (!value.backgroundImage) value.backgroundImage = config.backgroundImage;
    },
    createGroups() {
      let itm = _.cloneDeep(this.startGameConfig);
      itm.items = [];
      let tmpItems = itm.groups;
      if (itm.pick) {
        this.shuffle(tmpItems);
        let tmpItm = tmpItems.slice(0, itm.pick);
        tmpItems = tmpItm;
      }
      if (itm.shuffleGroups) this.shuffle(tmpItems);
      tmpItems.forEach((el) => {
        if (itm.shuffleInsideItems) {
          this.shuffle(el.items);
        }
        el.items.forEach((elInside) => {
          itm.items.push(elInside);
        });
      });
      console.log(tmpItems);
      for (let [i, its] of tmpItems.entries()) {
        for (let its2 of its.items) {
          this.tableOfIndexes.push(i);
        }
      }
      this.createItems(itm);
    },
    createItems(value) {
      value.items.forEach((el, index) => {
        if (el.audioSrc || el.text || el.image) {
          el.correctId = index;
          el.correctStatus = false;
          if (el.alwaysCorrect) el.correctStatus = true;
          this.items.push(el);
        }
        if (el.correct.audioSrc || el.correct.text || el.correct.image) {
          el.correct.correctId = index;
          el.correct.correctStatus = false;
          if (el.alwaysCorrect) el.correct.correctStatus = true;
          this.correct.push(el.correct);
        }
      });
      if (value.pick && !value.groups) {
        this.shuffle(this.items);
        let tmpItm = this.items.slice(0, value.pick);
        this.items = tmpItm;
        tmpItm = [];
        this.items.forEach((el) => {
          this.correct.forEach((corr) => {
            if (el.correctId == corr.correctId) tmpItm.push(corr);
          });
        });
        this.correct = tmpItm;
      }
      if (value.shuffle) this.shuffle(this.items);
      this.items.forEach((it, idIndex) => {
        this.setItem(it, idIndex, value.layoutItems, value.itemsConfig);
      });
      if (value.shuffleCorrect) this.shuffle(this.correct);
      this.correct.forEach((corr, indexCorr) => {
        this.setItem(corr, indexCorr, value.layoutCorrectItems, value.correctItemsConfig);
      });
    },
    init() {
      if (!this.preventResetTable) {
        this.tableOfGroupIndexes = new Array(this.startGameConfig.groups.length).fill(-1);
        this.preventResetTable = true;
      } else {
        this.tableOfGroupIndexes = Array.from(this.tableCopy);
      }
      this.tableOfIndexes = [];
      if (this.startGameConfig.groups) this.createGroups();
      else {
        let itm = _.cloneDeep(this.startGameConfig);
        this.createItems(itm);
      }
    },
    setValue(value, defaultValue) {
      if (value) return value;
      else return defaultValue;
    },
    giveMeImagePlease(path) {
      return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
    },
    resetGameAction() {
      if (this.maskData.length > 0) for (let m of this.maskData) m.isWrapped = true;
      this.checkIfLocked();
      if (this.currentIndex != -1) if (this.items[this.currentIndex].audio) this.items[this.currentIndex].audio.stop();
      this.canIPlayASong = true;
      this.items = [];
      this.blockItems = false;
      this.currentIndex = -1;
      this.hoverOnIcon = [];
      this.correct = [];
      this.init();
    },
    shuffle(a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
    setGameAudio() {
      if (this.startGameConfig.audio) {
        if (this.startGameConfig.audio.positive) {
          this.audioPositive = new Howl({
            src: this.giveMeImagePlease(this.startGameConfig.audio.positive),
            autoplay: false,
            loop: false,
            volume: 0.5,
          });
        }
        if (this.startGameConfig.audio.click) {
          this.audioClick = new Howl({
            src: this.giveMeImagePlease(this.startGameConfig.audio.click),
            autoplay: false,
            loop: false,
            volume: 0.5,
          });
        }
        if (this.startGameConfig.audio.negative) {
          this.audioNegative = new Howl({
            src: this.giveMeImagePlease(this.startGameConfig.audio.negative),
            autoplay: false,
            loop: false,
            volume: 0.5,
          });
        }
      }
    },
  },
  destroyed() {},
  computed: {
    backgroundImageUrl() {
      return 'static/' + this.startGameConfig.background;
    },
  },
};
</script>
<style lang="sass" scoped>
// @import '~pretty-checkbox/src/pretty-checkbox.scss';
@import '~@/assets/sass/variable'
@import '~@/assets/sass/iconColor'
$backgroundWidth: 1906px
$backgroundHeight: 900px
$backgroundOffsetTop: 140px
$backgroundOffsetLeft: 0
.main-img
  position: fixed
  object-fit: cover
.mz-listen-and-point
  font-family: $gameFontFamily
  background-size: contain
  background-repeat: no-repeat
  position: absolute
  top: $backgroundOffsetTop
  left: $backgroundOffsetLeft
  height: $backgroundHeight
  width: 1920px
  // top: 50px
  display: flex
  justify-content: center
  align-items: center
  // flex-basis: 30%
  flex-wrap: wrap
  .mz-listen-and-point-item
    position: absolute
    display: flex
    justify-content: center
    align-items: center
    cursor: pointer
    transition: .3s
    .mz-listen-and-point-item-img
      width: 100%
      height: 100%
      top: 0
      left: 0
      position: absolute
    .blocker, .mz-listen-and-point-item-correct-items, .mz-listen-and-point-item-incorrect-items
      width: 100%
      height: 100%
      z-index: 1
      position: absolute
      top: 0
      left: 0
      cursor: pointer
      .mz-listen-and-point-item-correct-image, .mz-listen-and-point-item-incorrect-image
        position: absolute
    p
      margin: 0
    .audio
      display: flex
      justify-content: center
      align-items: center
      posistion: absolute
      border-radius: 50%
      color: $secondIconColor
      background-color: $firstIconColor
      transition: 0.2s
      &:hover
        color: $firstIconColor
        background-color: $secondIconColor
      .mz-items-text
        max-width: 100%
        max-height: 100%
        user-select: none
        margin: 0
      .audio-svg-button
        width: 100%
        height: 100%
        fill: white
        transition: 0.2s
        &:hover
          fill: #00a8ec



.memory-fade-leave-active, .memory-fade-enter-active
  transition: all .3s linear
.memory-fade-leave-to, .memory-fade-enter
  opacity: 0
</style>
